import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useCallback,
} from 'react'
import { Box, TextInput, Text, Image } from 'grommet'
import { Close, Drag, Clone, Image as ImageIcon, Trash } from 'grommet-icons'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
// import { useDarkMode } from '../../contextHook/darkMode'
import {
  itemToggleChanged,
  itemCloseClicked,
  itemWheelChanged,
  itemWeightChanged,
  itemDuplicateClicked,
  itemImageChanged,
} from '../../redux/homepage/actions'
import { setIsEditing } from '../../redux/turntable/actions'
import {
  UploadInput as ImageInput,
  CheckBox,
  RelativeBox,
  AbsoluteBox,
} from '../Common'
import { device } from '../../theme/device'
import TipDrop from '../Button/TipDrop'
import IconButton from '../Button/IconButton'
import ImageUtil from '../../utils/imageUtil'
import { rgba, cssVar } from 'polished'
// import { useClickOutside } from '../../hook/useClickOutside'

const Container = styled(Box)`
  flex-shrink: 0;
  padding-right: 6px;
`

const MainInput = styled(TextInput)`
  background-color: ${props => props.theme.global.colors[props.bgColor]};
  border: none;
  border-radius: 0px;
  /* padding: 0.5rem; */
`

const ImageLabel = styled.label`
  background-color: ${props => props.theme.global.colors.secondaryBg};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0rem 0.8rem;
  align-self: stretch;
`

const WeightInput = styled.input`
  background-color: ${props => props.theme.global.colors[props.bgColor]};
  color: ${props => props.theme.global.colors.text};
  border: none;
  border-radius: 0px;
  width: 4rem;
  text-align: center;
  outline: none;
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`

const DuplicateIcon = styled(Clone)`
  height: 24px;
  width: 24x;
  @media ${device.medium} {
    height: 22px;
    width: 22px;
  }
`

const CloseIcon = styled(Close)`
  height: 24px;
  width: 24x;
  @media ${device.medium} {
    height: 22px;
    width: 22px;
  }
`

const TouchBox = styled(Box)`
  cursor: move;
  /* touch-action: none; */
  -webkit-touch-callout: none;
  /* user-select: auto; */
  user-select: none;
`

const DragIcon = styled(Drag)`
  height: 24px;
  width: 24x;
  @media ${device.medium} {
    height: 22px;
    width: 22px;
  }
`

// const InputBox = styled(Box)`
/* max-width: 35.8rem;
    @media ${device.medium} {
      max-width: 39.2rem;
    } */
// `
const ListItem = forwardRef(
  (
    {
      // provided,
      name,
      count,
      filtered,
      weight,
      image,
      index,
      style,
      inputFocus = null,
      weightFocus = null,
      attributes,
      listeners,
      isDragging = false,
    },
    ref,
  ) => {
    // const toolColors = useSelector(state => state.settings.wheelColors.colors)
    const weightOn = useSelector(state => state.main.weightOn)
    // const filteredChoices = useSelector(state => state.main.filteredChoices)
    const [inputValue, setInputValue] = useState(name)
    const [weightValue, setWeightValue] = useState(weight || 1)
    const [initDone, setInitDone] = useState(false)
    // const { value: darkMode } = useDarkMode()
    const [isFocused, setFocused] = useState(false)
    const [isImageFocused, setImageFocused] = useState(false)
    // const [displayValue, setDisplayValue] = useState(name)
    // const [checked, setChecked] = useState(!filtered)inputR
    const inputRef = useRef(null)
    const weightRef = useRef(null)
    const imageFileRef = useRef(null)
    // useClickOutside(imageRef, () => {
    //   if (isImageFocused) {
    //     setImageFocused(false)
    //   }
    // })

    useEffect(() => {
      if (inputFocus?.focus === index && inputRef.current) {
        // Move element into view when it is focused
        if (initDone) {
          // do sinputFocus.omething
          inputRef.current.focus()
        }
      }
    }, [inputFocus?.focus === index])

    useEffect(() => {
      if (weightFocus?.focus === index && weightRef.current) {
        // Move element into view when it is focused
        if (initDone) {
          // do sinputFocus.omething
          weightRef.current.focus()
        }
      }
    }, [weightFocus?.focus === index])

    useEffect(() => {
      if (isFocused) {
        //setisediting true here, so run later
        dispatch(setIsEditing(isFocused))
      }
    }, [isFocused])

    // const handleSelect = useCallback(() => {
    //   setFocus(index)
    // }, [])

    useEffect(() => {
      if (!initDone) {
        setInitDone(true)
      } else {
        const timeOutId = setTimeout(
          () => dispatch(itemWheelChanged(inputValue, index)),
          200,
        )
        return () => clearTimeout(timeOutId)
      }
    }, [inputValue])

    const dispatch = useDispatch()

    const inputChanged = event => {
      event.preventDefault()
      const newValue = event.target.value
      // let newChoices = choices.slice(0)
      // newChoices[index].name = newValue
      setInputValue(newValue)
      // dispatch(setChoices(newChoices.slice(0)))
    }
    const handleWeightChange = event => {
      let { value, min } = event.target
      if (value === '') {
        setWeightValue(value)
        return
      } else {
        value = Math.max(Number(min), Number(value))
        setWeightValue(value)
        dispatch(itemWeightChanged(value, index))
      }
    }

    const handleImageChange = useCallback(event => {
      if (event.target.files.length > 0) {
        const file = event.target.files[0]
        const reader = new FileReader()
        reader.onload = async e => {
          const dataUri = await ImageUtil.optimizeSliceImage(e.target.result)
          dispatch(itemImageChanged(dataUri, index))
          dispatch(setIsEditing(false)) // setisediting false here, so run first
          setFocused(false)
        }
        reader.readAsDataURL(file)
      }
      // window.removeEventListener('focus', handleFocusBack)
      imageFileRef.current.removeEventListener('cancel', handleFocusBack)
    })

    const clickedFileInput = useCallback(() => {
      imageFileRef.current.addEventListener('cancel', handleFocusBack)
    }, [])

    const deleteImage = useCallback(async () => {
      dispatch(itemImageChanged(null, index))
      dispatch(setIsEditing(false)) // setisediting false here, so run first
      setImageFocused(false)
      setFocused(false)
    }, [])

    //this is to make main input expand and retract
    const onMainInputFocus = useCallback(() => setFocused(true), [])
    const onMainInputBlur = useCallback(event => {
      if (
        event.relatedTarget?.id &&
        (event.relatedTarget.id === `ImageFileInputItem${index}` ||
          event.relatedTarget.id === `ItemImageBox${index}`)
      )
        return
      dispatch(setIsEditing(false)) // setisediting false here, so run first
      setFocused(false)
    }, [])

    const onMouseDown = useCallback(event => {
      event.preventDefault()
    }, [])

    // this is to remove focus when upload file cancel
    const handleFocusBack = useCallback(() => {
      dispatch(setIsEditing(false))
      setFocused(false)
      // window.removeEventListener('focus', handleFocusBack)
      imageFileRef.current.removeEventListener('cancel', handleFocusBack)
    }, [])

    // this is to make image delete or cancel
    const onImageBoxBlur = useCallback(() => {
      dispatch(setIsEditing(false)) // setisediting false here, so run first
      setImageFocused(false)
      setFocused(false)
    }, [])

    const onImageBoxFocus = useCallback(() => {
      dispatch(setIsEditing(true)) // setisediting false here, so run first
      setImageFocused(true)
    }, [])

    // const onImageTrashMouseDown = useCallback((event) => {
    //   event.preventDefault()
    // }, [])

    // const isImage = isImageData(name)
    return (
      <Container ref={ref} direction="row" align="stretch" style={style}>
        {/* <Box direction="row" flex={true} align="center" pad="0px"> */}
        <Box direction="row" gap=".5rem" flex={true}>
          {weightOn && (
            <WeightInput
              ref={weightRef}
              min="1"
              type="number"
              enterKeyHint="done"
              value={weightValue}
              onChange={handleWeightChange}
              bgColor={isDragging ? 'primaryBg' : 'secondaryBg'}
              onClick={() => weightFocus?.handleClick(index)}
              onKeyDown={weightFocus?.handleKeyDown}
            />
          )}
          <RelativeBox fill={true}>
            <Box
              direction="row"
              align="center"
              pad="0px"
              margin={{ right: isFocused ? '.7rem' : '0' }}
            >
              <MainInput
                type="text"
                enterKeyHint="done"
                ref={inputRef}
                // tabIndex={isFocused ? -1 : 0}
                value={inputValue}
                onChange={event => inputChanged(event)}
                bgColor={isDragging ? 'primaryBg' : 'secondaryBg'}
                onClick={() => inputFocus?.handleClick(index)}
                onKeyDown={inputFocus?.handleKeyDown}
                onFocus={onMainInputFocus}
                onBlur={onMainInputBlur}
              ></MainInput>
              {!image && isFocused && (
                <TipDrop content="Upload Image" position="bottom">
                  <ImageLabel
                    htmlFor={`ImageFileInputItem${index}`}
                    onMouseDown={onMouseDown}
                  >
                    <ImageIcon color="placeholder" size="22px" />
                  </ImageLabel>
                </TipDrop>
              )}
              <ImageInput
                ref={imageFileRef}
                tabIndex="-1"
                id={`ImageFileInputItem${index}`}
                onChange={handleImageChange}
                onClick={event => {
                  clickedFileInput()
                  event.target.value = null
                }}
                type="file"
                accept="image/*"
              />
              {image && (
                <RelativeBox
                  id={`ItemImageBox${index}`}
                  background={isDragging ? 'primaryBg' : 'secondaryBg'}
                  pad=".3rem .3rem"
                  height="4rem"
                  width="4rem"
                  align="center"
                  tabIndex={-1}
                  onFocus={onImageBoxFocus}
                  onBlur={onImageBoxBlur}
                >
                  <Image
                    src={image}
                    fit="contain"
                    style={{ cursor: 'pointer' }}
                  />
                  {isImageFocused && (
                    <AbsoluteBox
                      width="100%"
                      height="100%"
                      top="0"
                      left="0"
                      align="center"
                      justify="center"
                      style={{
                        zIndex: 2,
                      }}
                      background={`${rgba(cssVar('--mid'), 0.6)}`}
                    >
                      <IconButton
                        icon={<Trash size="medium" color="iconDarkLight" />}
                        onMouseDown={onMouseDown}
                        onClick={deleteImage}
                      />
                    </AbsoluteBox>
                  )}
                </RelativeBox>
              )}
            </Box>
            {!isFocused && count > 0 && (
              <AbsoluteBox
                background="inputDarkLight"
                // {
                //   !darkMode || toolColors.length < 3
                //     ? toolColors[0]
                //     : toolColors[2]
                // }
                pad={{ horizontal: '3px', vertical: '2px' }}
                // margin={{ right: !image ? '.7rem' : '3.8rem' }}
                round="5px"
                top="50%"
                right={!image ? '.7rem' : '3.8rem'}
                style={{ transform: 'translateY(-50%)' }}
                align="center"
                justify="center"
              >
                <Text size="1.6rem" color="invertTextStrong" textAlign="center">
                  +{count}
                </Text>
              </AbsoluteBox>
            )}
          </RelativeBox>
        </Box>
        {/* </Box> */}
        {!isFocused && (
          <>
            <TouchBox
              {...listeners}
              {...attributes}
              justify="center"
              pad={{ horizontal: '.3rem' }}
              tabIndex="-1"
            >
              <DragIcon color="greyIcon" />
            </TouchBox>

            <Box
              direction="row"
              // width={size === 'medium' ? '6.4rem' : '8.4rem'}
              align="center"
              justify="between"
            >
              <IconButton
                tabIndex="-1"
                icon={<DuplicateIcon color="greyIcon" />}
                onClick={() => {
                  dispatch(itemDuplicateClicked(index))
                }}
                pad="0 .3rem"
              />
              <CheckBox
                tabIndex="-1"
                pad="0 .3rem"
                checked={!filtered}
                onChange={event => {
                  const status = event.target.checked
                  // setChecked(status)
                  // setTimeout(() => {
                  dispatch(itemToggleChanged(status, index))
                  // }, 50)
                }}
                // size={size}
                // activeColor={
                //   !darkMode || toolColors.length < 3
                //     ? toolColors[0]
                //     : toolColors[2]
                // }
                size="24px"
                sizeMedium="22px"
              />
              <IconButton
                tabIndex="-1"
                icon={
                  <CloseIcon
                    color="reject"
                    // size={size === 'medium' ? '3rem' : '3.5rem'}
                  />
                }
                onClick={() => dispatch(itemCloseClicked(index))}
                pad="0 .5rem 0 .3rem"
              />
            </Box>
          </>
        )}
      </Container>
    )
  },
)

export default React.memo(ListItem)
